module.exports = __webpack_public_path__ + "static/media/jirafa_big.9b766407.png";